import { useEffect, useMemo, useState } from "react";

/** Pagination client-side pour listes en mémoire (localStorage, stores). */
export function useClientPagination<T>(
  items: T[],
  resetDeps: unknown[] = [],
  defaultPageSize = 25,
) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- resetDeps fourni par l'appelant
  }, [pageSize, ...resetDeps]);

  const totalItems = items.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(page, totalPages);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const pagedItems = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, safePage, pageSize]);

  return {
    page: safePage,
    pageSize,
    totalPages,
    totalItems,
    pagedItems,
    setPage,
    setPageSize,
  };
}
